import React from 'react';
import { VideoInput } from 'components/Video/VideoInput';
import styles from './videoFormInput.module.scss';
import classNames from 'classnames/bind';
import { toast } from 'react-toastify';
import i18n from 'i18n';

export const VideoFormInput: React.FunctionComponent<any> = (props) => {
  const cssClassNames = classNames.bind(styles);

  const onFileChange = (file) => {
    if (!file) {
      props.onChange &&
        props.onChange({
          file: undefined,
          url: undefined
        });
      return;
    }
    const validTypes = ['video/mp4'];
    if (validTypes.indexOf(file.type) === -1) {
      props.onChange &&
        props.onChange({
          file,
          url: props.url
        });
      return;
    }

    const video = document.createElement('video');
    video.addEventListener('loadedmetadata', () => {
      props.onChange &&
        props.onChange({
          file,
          width: video.videoWidth,
          height: video.videoHeight,
          duration: video.duration,
          url: props.url
        });
    });
    video.addEventListener('error', () => {
      toast.error(i18n.t<string>('videoFormInput.errors.loadingVideo'));
      props.onChange &&
        props.onChange({
          file: undefined,
          url: undefined
        });
    });
    video.src = URL.createObjectURL(file);
  };
  const mainClassName = cssClassNames('videoPreview', props.className, {
    showErrorBorder: props.errorBorderHint,
    showSolidBorder: props.url || props.file
  });
  return (
    <div className={mainClassName}>
      <div className={styles.videoContent}>
        <VideoInput {...props} onChange={onFileChange} />
      </div>
    </div>
  );
};
